__webpack_require__.p = "/cluster-g-events/";